import { ProductImportReferencesResponse } from "./../models/product-import.types";
import { Injectable } from "@angular/core";
import { ApiAuthService } from "./api-auth.service";

import {
  ProductImportCommitRequest,
  ProductImportCommitResponse,
  ProductImportPreviewResponse,
  ProductImportRow,
} from "../models/product-import.types";

@Injectable({
  providedIn: "root",
})
export class ProductImportService extends ApiAuthService {
  private readonly url = `${this.baseUrl}/product-import`;

  async preview(file: File): Promise<ProductImportPreviewResponse> {
    const formData = new FormData();
    formData.append("file", file);

    return this.request(() =>
      this.http
        .post<ProductImportPreviewResponse>(`${this.url}/preview`, formData)
        .toPromise(),
    );
  }

  async validateRows(
    rows: ProductImportRow[],
  ): Promise<ProductImportPreviewResponse> {
    return this.request(() =>
      this.http
        .post<ProductImportPreviewResponse>(`${this.url}/validate-rows`, {
          rows,
        })
        .toPromise(),
    );
  }

  async importProducts(
    payload: ProductImportCommitRequest,
  ): Promise<ProductImportCommitResponse> {
    return this.request(() =>
      this.http
        .post<ProductImportCommitResponse>(`${this.url}/commit`, payload)
        .toPromise(),
    );
  }

  downloadTemplate(): void {
    window.open(`${this.url}/template`, "_blank");
  }

  async getReferences(partnerId?: string | number): Promise<ProductImportReferencesResponse> {
    return this.request(() =>
      this.http
        .get<ProductImportReferencesResponse>(`${this.url}/references?partnerId=${encodeURIComponent(String(partnerId))}`)
        .toPromise(),
    );
  }
}
